import PayoutsPage from "./payouts";

export default PayoutsPage;